import React, { useState } from "react";
import { useTenantsApp } from "../../Context/TenantsApp/TenantsAppContext";
import { SET_INSTANCE_ID, SET_TENANT_ID, TOGGLE_DELETE_APP_INSTANCE_DIALOG, DELETE_TENANT, DELETE_TENANT_INSTANCE } from "./TenantsAppEvents";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import { getProject, updateProject, deleteProject } from "../../API/Project/project";
import { deleteInstanceOnRuntime } from "../Helpers/Runtime/runtime";
import { useMsal } from "@azure/msal-react";
import { updateTenantProject, deleteTenantProject } from "../../API/Tenant/Tenant";
import { deleteDirectory } from "../Helpers/DateLakeStorage";

const DeleteTenantAppInstance = () => {
    const msalContext = useMsal();
    const { state, dispatch } = useTenantsApp();
    const { selectedInstanceId, selectedTenantId, tenants } = state;
    const selectedTenant = tenants.find(tenant => tenant._id === selectedTenantId);
    const selectedInstance = selectedTenant ? selectedTenant.project?.tenantProject?.instances?.find(instance => instance._id === selectedInstanceId) : null;

    const [inProgress, setInProgress] = useState(false);

    if (!selectedTenant || !selectedInstanceId) {
        return null; // or handle the case where no tenant or instance is selected
    }

    const handleClose = () => {
        dispatch({ type: SET_TENANT_ID, payload: null });
        dispatch({ type: SET_INSTANCE_ID, payload: null });
        dispatch({ type: TOGGLE_DELETE_APP_INSTANCE_DIALOG });
    }

    const handleDeleteTenantApp = async () => {
        debugger
        setInProgress(true);
        try {
            const projectToDelete = await getProject(selectedTenant.project.tenantProjectId);
            if (!projectToDelete) {
                dispatch({ type: DELETE_TENANT, payload: state.selectedTenantId });
                handleClose();
                return;
            }

            let { instances } = projectToDelete;

            const instanceToDelete = instances.find(instance => instance._id === selectedInstanceId);
            if (!instanceToDelete) {
                dispatch({
                    type: DELETE_TENANT_INSTANCE,
                    payload: {
                        tenantId: selectedTenantId,
                        instanceId: selectedInstanceId,
                    }
                });
                console.error("Instance not found in project");
                return;
            }

            const response = await deleteInstanceOnRuntime(msalContext, projectToDelete.organizationId, projectToDelete.name, instanceToDelete._id);
            if (response.status === "Success") {
                const updatedInstances = instances.filter(instance => instance._id !== instanceToDelete._id);
                if (updatedInstances.length === 0) {
                    let projectResponse = await deleteProject(projectToDelete._id);
                    await updateTenantProject(selectedTenant._id, selectedTenant.masterProjectId, { status: "deleted" });
                    await deleteTenantProject(selectedTenant._id, selectedTenant.masterProjectId);
                    if (projectResponse.status === "Success") {
                        let path = projectToDelete.organizationId + "/" + projectToDelete._id;
                        deleteDirectory(path, projectToDelete._id);
                    }
                    dispatch({ type: DELETE_TENANT, payload: state.selectedTenantId });
                } else {
                    await updateProject(projectToDelete._id, { instances: updatedInstances });
                    dispatch({
                        type: DELETE_TENANT_INSTANCE,
                        payload: {
                            tenantId: selectedTenantId,
                            instanceId: selectedInstanceId,
                        }
                    });
                }
            }
            handleClose();
        } catch (error) {
            console.error("Error deleting tenant app instance:", error);
        } finally {
            setInProgress(false);
        }
    }

    return (
        <RemoveDialog
            showLoader={inProgress}
            Title={"Delete Tenant App Instance"}
            toggleDeleteDialog={handleClose}
            message={`Are you sure you want to delete ${selectedInstance.instanceName.toLowerCase()} tenant app instance? This action cannot be undone.`}
            message2={"This will permanently delete the app and all associated data in the tenant instance. This action cannot be undone."}
            message3={"Do you want to proceed?"}
            onDelete={handleDeleteTenantApp}
            onCancel={handleClose}
            deleteButtonText={"Delete"}
            cancelButtonText={"Cancel"}
        />
    )
}

export default DeleteTenantAppInstance;